import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/newTableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import DatePicker from 'components/sales/datePicker/datePicker';
import { Button, Form, Container, FormGroup,Row, Col  } from 'react-bootstrap';
import Notfound from 'pages/notfound/notfound';
import ModalPop from 'components/sales/modal/modal';
import axios from "services/interceptor/Interceptor";
import Config from "services/config/config";
import {toast} from "react-toastify";
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import PanelCardWithHeading from 'components/tickets/panelCardWithHeading';
import moment from 'moment';
import FileUpload from "components/sales/fileUpload/fileUpload";
import { addDays, subDays } from 'date-fns';

const RaiseUpdateInstallationDate = ({ 
  getContractDetails,
  viewDetails,
  createInstallationDateChange,
  installationDateChangeRequest,
  installationDateChangeListing,
  getInstallationDateChangeListing,
  documentUploadUrlPublic,
  documentUrlDataPublic,
  history,
  match
}) => {
  const [leadId, setleadId] = useState();
  const [siteId, setSiteId] = useState("");
  const [roleId, setRoleId] = useState("");
  const [pageCount, setPageCount] = useState(0);
  const [commId, setcommId] = useState();
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [details, setDetails] = useState(null);
  const [formData, setFormData] = useState({
    changed_date: "", 
    request_remarks: "", 
  });
  const [listData, setListData] = useState([]);
  const [isRender, setIsRender] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [actionData, setActionData] = useState();
  const [closed, setClosed] = useState(false);
  const handleModalHide = () => {
    setIsModal(false);
    window.location.reload();
  }
  const [remark, setRemark] = useState("");
  const [oldDate, setOldDate] = useState("");
  const [attachment,setAttachment]=useState("");
  const [isModalSuccess, setIsModalSuccess] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      if (localStorage.getItem('loginDetails') !== 'undefined') {
        const roleId = (await JSON.parse(localStorage.getItem('loginDetails'))) &&
        JSON.parse(localStorage.getItem('loginDetails'))?.roleId;
        setRoleId(roleId);
      }
    })();
  }, []);
  useEffect(() => {
    
    (async () => {
      if (localStorage.getItem('viewDetail') !== 'undefined') {
        const leadTypeId =
          (await JSON.parse(localStorage.getItem('viewDetail'))) &&
          JSON.parse(localStorage.getItem('viewDetail'))[0]?.lead_type_id;
        const requestData = {
          lead_id: leadId,
          commId:commId,
          lead_type: leadTypeId,
        };
        console.log(requestData)
        if (leadId) {
          setIsLoading(true);
          const res = await getContractDetails(requestData);
          if (res === null || res === '') {
            setIsRender(true);
          }
          setIsLoading(false);
        }
      }
    })();
  }, [getContractDetails, leadId,commId]);
  useEffect(() => {
    if (viewDetails) {
      setDetails(viewDetails);
    }
    setOldDate(viewDetails?.postsale_data?.commercial?.installation_start_date)
    setleadId(match.params.id ? match.params.id : match.params.lead_id);
    setcommId(match.params.comm_id ? match.params.comm_id : match.params.comm_id);
  }, [viewDetails, match.params]);

  const handleChange = (value) => {
    setFormData((prevDetails) => ({
      ...prevDetails,
      request_remarks: value,
    }));
  };

  const handleDateChange = (dateString) => {
    setFormData((prevDetails) => ({
      ...prevDetails,
      changed_date: dateString,
    }));
  };
  
  const handleSubmit =async (e) => {
      e.preventDefault();
      setIsLoading(true)
      let res = await createInstallationDateChange(match.params.comm_id,formData)
      setIsLoading(false)
      setFormData({
        changed_date: "", 
        request_remarks: "",
        attachment:""
      });
      console.log(res);
      if (res==true) {
        setIsModalSuccess(true)
        setIsModal(true);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
      await getContractDetails({ lead_id: leadId, commId: commId });
  }
  const handleSuccessModalHide = () => {
    setIsModalSuccess(false);
    setError(""); 
    history.goBack();
  };
  
  const headers = [
    'Site No.',
    'Client Name',
    'Site Created By',
    'Approved By',
    'Changed Date',
    'Remarks',
    'Status',
  ];
  useEffect(() => {
    (async () => {
        setIsLoading(true);
        const res=await getInstallationDateChangeListing(1, match.params.comm_id);
        setIsLoading(false);
      })();
  }, []);
  
  useEffect(() => {
    const tableData = [
      "id",
      "site_no",
      "client_name",
      "site_created_by",
      "approved_by",
      "changed_date",
      "request_remarks",
      'status',
    ];

    if (installationDateChangeListing && installationDateChangeListing?.data) {
      const data = installationDateChangeListing?.data?.map((element) =>
          Object.assign(
              {},
              ...tableData.map((key) => (
                  {
                   [key]: element[key],
                  })

              )
          )
      );
      data && setListData(data);
      setPageCount(Math.ceil(installationDateChangeListing?.total / installationDateChangeListing?.per_page));
      
    }
  }, [installationDateChangeListing]);

  var minimumDate;
  var maximumDate;
  if(roleId === 4){
    minimumDate= addDays(new Date(),1); 
    maximumDate= subDays(new Date(oldDate),1);
  }else{
    minimumDate = addDays(new Date(), 10);
  }

  return isRender ? (
    <Notfound />
  ) : (
    <Layout
      title={'Change Installation date'}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/sites-listing`}
    >
      <div className="container my-5">
        <div className="row">
          <div className="col-md-12">
            <div className="card mb-4 shadow-sm">
            <PanelCardWithHeading title={roleId === 4 ? 'Raise Prepone Request' : 'Raise Postpone Request'} />
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-6">
                        <ConstantInput
                            label={'Business Name'}
                            type="text"
                            value={viewDetails
                              ? viewDetails?.lead_data?.client_name
                              : 'N/A'}    
                              disabled={true}   
                          />
                      </div> 
                      <div className='col-md-6'>
                        <DatePicker
                          label="Current Installation Date"
                          handleChange={handleDateChange}
                          value={moment(oldDate, 'YYYY-MM-DD').format('DD-MM-YYYY')}
                          displayFormat="DD-MM-YYYY"
                          disabled={true}
                        />
                      </div>
                    </div>
                    <div className='row'>
                      <div className="col-md-6">
                        <DatePicker
                          label="New Installation Date:"
                          handleChange={handleDateChange}
                          minimumDate={minimumDate}
                          maxDate={(maximumDate!==undefined&&maximumDate!==null)?maximumDate:null}
                          value={formData.changed_date}
                          required={true}
                        />
                      </div>
                    </div>
                  <div className="row">
                    <div className="col-md-6">
                      <ConstantInput
                          label={localization.remark}
                          required={true}
                          isStarRequired={true}
                          type="text"
                          value={formData.request_remarks}
                          fullWidth={true}
                          handleChange={handleChange}
                        />
                    </div>
                    <div className="col-md-6">
                      <FileUpload
                          id="attachment"
                          accept=".pdf,.png,.jpg,.jpeg,.doc"
                          documentUploadUrl={documentUploadUrlPublic}
                          documentUrlData={documentUrlDataPublic}
                          onChange={(val) =>{
                            console.log(val);
                            setFormData((prevFormData) => ({
                              ...prevFormData,
                              attachment: val,
                            }));
                          }}
                          showFileName={false}
                          >
                          <span className="btn btn-transparent">
                            {localization.uploadAttachment}
                          </span>
                      </FileUpload>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <button type="submit" className="btn btn-primary mt-3">
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalPop
            title={"Success"}
            show={isModalSuccess}
            handleModalHide={handleSuccessModalHide}
          >
            {error ? (
              <div className="error-message">{error}</div>
            ) : (
              <div className="text-center">
                <div className="success">
                  <img src={Images?.tick} alt="" />
                </div>
                <h5>{"Request Created successfully"}</h5>
              </div>
            )}
            <Button variant="secondary" onClick={handleSuccessModalHide}>
              OK
            </Button>
          </ModalPop>
          
    </Layout>
  );

  };

RaiseUpdateInstallationDate.propTypes = {
  getDetails: PropTypes.func.isRequired,
  viewDetails: PropTypes.object,
  installationDateChangeListing: PropTypes.any, 
  getInstallationDateChangeListing: PropTypes.func,
  match: PropTypes.object.isRequired
};
export default RaiseUpdateInstallationDate;

